import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const ESGVerificationDetailFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .main-content {
    .form-wrapper {
      .info-wrapper {
        margin-bottom: 32px;
      }

      .form-group {
        label {
          flex: 0 0 200px;
          text-align: left;
          justify-content: flex-start;
          margin-right: 0;
          padding-right: 20px;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
